/** Trigger a client-side text download (no server round-trip). */
export function downloadText(filename: string, text: string, mime = 'text/plain'): void {
  try {
    const blob = new Blob([text], { type: `${mime};charset=utf-8` });
    const url = URL.createObjectURL(blob);
    const a = document.createElement('a');
    a.href = url;
    a.download = filename;
    document.body.appendChild(a);
    a.click();
    a.remove();
    window.setTimeout(() => URL.revokeObjectURL(url), 0);
  } catch {
    /* download may be blocked; copy is the fallback path in the UI */
  }
}
